const data = (localStorage.getItem('dataCharges'));
const menudata = JSON.parse(data)


export default menudata
